import { useTheme } from 'styled-components';
import { IconButton, IconName, Typography, Stack, StackItem, getSpacingToken } from '@optimus-web/core';

interface SummaryRowProps {
    label: React.ReactNode;
    body: React.ReactNode;
    action?(): void;
    dataTestId?: string;
}

const SummaryRow = ({ label, body, action, dataTestId }: SummaryRowProps) => {
    const theme = useTheme();

    return (
        <Stack distribution="space-between" fill spacing="200">
            <StackItem width={`${getSpacingToken('1200')({ theme })}px`}>
                <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                    {label}
                </Typography>
            </StackItem>
            <StackItem grow>{body}</StackItem>
            <StackItem>
                {action ? (
                    <IconButton
                        size="small"
                        variant="tertiary"
                        data-test-id={dataTestId}
                        onClick={action}
                        icon={IconName.ChevronRight}
                        type="submit"
                    />
                ) : null}
            </StackItem>
        </Stack>
    );
};

export default SummaryRow;
